var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#EFF6F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1251 50.3971H29.7322C27.6709 50.3971 26 48.7261 26 46.6649V31.7363C26 29.6751 27.6709 28.0041 29.7322 28.0041H53.3692C54.4857 27.9401 55.5078 28.6289 55.8676 29.6878C56.2273 30.7467 55.8363 31.9156 54.9118 32.5449L43.3421 41.4399C41.9425 42.5159 39.9804 42.464 38.6396 41.3155L31.4614 35.1699C31.1236 34.881 30.9656 34.4338 31.0469 33.9968C31.1282 33.5598 31.4365 33.1994 31.8555 33.0513C32.2746 32.9033 32.7409 32.99 33.0787 33.2789L40.2569 39.4245C40.7137 39.7951 41.3676 39.7951 41.8244 39.4245L53.3941 30.5295L29.7322 30.4922C29.0451 30.4922 28.4881 31.0492 28.4881 31.7363V46.6649C28.4881 47.352 29.0451 47.909 29.7322 47.909H52.1251C52.8122 47.909 53.3692 47.352 53.3692 46.6649V36.7125C53.3692 36.0254 53.9262 35.4684 54.6132 35.4684C55.3003 35.4684 55.8573 36.0254 55.8573 36.7125V46.6649C55.8573 48.7261 54.1863 50.3971 52.1251 50.3971Z",
    fill: "#31795A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.521be763587bbd159d98cc582dd45d70.svg";
export { ForwardRef as ReactComponent };